let setupSubsectionReadMore = container =>
  $(container).find(".subsection-read-more .subsection-content").addClass("to-be-truncated").dotdotdot({
    after: "a.readmore",
    callback(isTruncated, orgContent) {
      let $content = $(this);
      $content.append(`\
<a class="subsection-read-more-link">${I18n.t("base.read_more")} &rsaquo;</a>\
`);
      return $content.one("click", () => $content.trigger("destroy.dot").removeClass("to-be-truncated is-truncated"));
    }
  })
;

$(document).ready(() => setupSubsectionReadMore(document.body));



// WEBPACK FOOTER //
// ./app/webpack/frontend/initializers/subsection_read_more.js